import { Link } from "react-router-dom";
import { useState } from "react";
import { useTrustScore } from "./trust/TrustProvider";
import { TrustBadge, TrustBadgeLightbox } from "./trust/TrustBadge";
import { BookmarkButton } from "./TermCard";
import { useBookmarks } from "../lib/bookmarks";

export const ProductCard = ({ product }) => {
  const { score } = useTrustScore(product.slug);
  const [open, setOpen] = useState(false);
  const { isBookmarked, toggle } = useBookmarks("products");
  const bookmarked = isBookmarked(product.slug);

  const handleBookmark = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(product.slug, {
      name: product.name,
      category_slug: product.category_slug,
    });
  };

  return (
    <>
      <Link
        to={`/produit/${product.slug}`}
        className="group block bg-bl-surface border border-bl-border overflow-hidden"
        data-testid={`product-card-${product.slug}`}
      >
        <div className="aspect-square overflow-hidden bg-bl-soft relative">
          {product.image_url ? (
            <img
              src={product.image_url}
              alt={product.name}
              loading="lazy"
              className="w-full h-full object-cover product-image-zoom"
            />
          ) : (
            <div className="w-full h-full grid place-items-center text-bl-textSoft text-sm">
              Beckyliss
            </div>
          )}
          {score && (
            <div
              style={{ position: "absolute", top: 10, right: 10, zIndex: 2 }}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
            >
              <TrustBadge score={score.global_score} size={44} testId={`trust-badge-${product.slug}`} />
            </div>
          )}
          <div style={{ position: "absolute", top: 10, left: 10, zIndex: 2 }}>
            <BookmarkButton
              bookmarked={bookmarked}
              onClick={handleBookmark}
              testId={`bookmark-product-${product.slug}`}
            />
          </div>
        </div>
        <div className="p-5">
          <p className="overline mb-2">{product.sku || "Beckyliss"}</p>
          <h4 className="font-serif text-xl text-bl-text leading-snug min-h-[3rem]">
            {product.name}
          </h4>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-sm text-bl-text font-medium">
              {product.price ? `${product.price.toFixed(2).replace('.', ',')} €` : '—'}
            </span>
            <span className="text-xs tracking-wide text-bl-dore underline-grow">
              Découvrir
            </span>
          </div>
        </div>
      </Link>

      <TrustBadgeLightbox
        open={open}
        onClose={() => setOpen(false)}
        slug={product.slug}
        initialData={score}
      />
    </>
  );
};
